<template>
  <div id="dashboardChannelMilestones">
    <div id="projectGrid" class="CustomGrid" v-if="propValSet">
      <DxDataGrid
        ref="projectGrid"
        :data-source="DS_Project"
        :remote-operations="false"
        :show-borders="false"
        :show-row-lines="true"
        :show-column-lines="true"
        mode="single"
        :rowAlternationEnabled="false"
        @cell-prepared="onCellPrepared"
        :showColumnHeaders="false"
        :onContentReady="onContentReady"
        :onRowPrepared="onRowPrepared"
      >
        <DxPaging :page-size="10" />
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="[5, 10, 20, 50]"
          :show-info="true"
        />
        <DxGroupPanel :visible="false"/>
          <DxGrouping :auto-expand-all="true"/>
        <DxSearchPanel :visible="false" :width="240" placeholder="Search..." />
        <DxColumn
          caption=" "
          data-type="string"
          :width="100"
          alignment="center"
          cell-template="infoTemplate"
        />
        <DxColumn
          :group-index="0"
          data-field="ClientProjectName"
          caption="Name"
          data-type="string"
          alignment="left"
          cell-template="nameTemplate"
          group-cell-template="groupCellTemplate"
        />
        <DxColumn
          data-field="PhaseName"
          caption="Phase"
          data-type="string"
          alignment="left"
          :width="300"
          cell-template="phaseTemplate"
        />

        <template #infoTemplate="cell">
          <div>
            <font-awesome-icon
              style="color: #006ca5; cursor: pointer;font-size:18px;"
              title="View Channels"
              icon="circle-info"
              @click="
                filterChannelsList(cell, cell.data.row.data, 'phase')
              "
            ></font-awesome-icon>
          </div>
        </template>
        <template #groupCellTemplate="cell">
          <div
            style="color: #006ca5; cursor: pointer;"
            @click="filterChannelsList(cell, cell.data.row.data, 'project')">
            {{ cell.data.value }}
          </div>
        </template>
          <template #phaseTemplate="cell">
          <div
            style="color: #006ca5; cursor: pointer;"
            @click="filterChannelsList(cell, cell.data.row.data, 'phase')">
            {{ cell.data.value }}
          </div>
        </template>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxSearchPanel,
  DxGroupPanel,
  DxGrouping
} from "devextreme-vue/data-grid";
import "devextreme/data/odata/store";
import { EventBus } from '../../../components/Events';
export default {
  name: "ProjectGrid",
  props: {
    DS_Project: Object,
    clientProjectId: Number,
    clientProjectPhaseID: Number
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxPaging,
    DxPager,
    DxGroupPanel,
    DxGrouping
  },
  data() {
    return {
      SelectedProjectPhaseID: this.clientProjectPhaseID,
      firstLoad: true,
      projectPhaseName: '',
      currentClientProjectPhaseID: this.clientProjectPhaseID,
      propValSet: false,
    };
  },
  watch: { 
    clientProjectPhaseID: function(newVal, oldVal) { 
       this.SelectedProjectPhaseID = newVal;
       this.currentClientProjectPhaseID = newVal;
       this.propValSet = true;
    },
  },
  mounted: function(){
    EventBus.$on('project-grid-filter', () => {
      this.propValSet = true;
    });
    setTimeout(() => {
      this.propValSet = true;
    }, 1000);
  },
  computed:{
    highlightGroup(){
      if(this.SelectedProjectPhaseID == null || this.SelectedProjectPhaseID == 0){
       return true;
      } else {
       return false;
      }
    }
  },
  methods: {
    onRowPrepared: function (e) {  
      if (e.rowType == "group" && this.highlightGroup) {  
        e.rowElement.style.backgroundColor ='lightcyan';  
      } else if(e.rowType == "group" && !this.highlightGroup){
         e.rowElement.style.backgroundColor ='white'; 
      }
    },
    onContentReady(e) {
      this.firstLoad = false;
      if(this.projectPhaseName != ''){
        this.$emit("set-phase-name", this.projectPhaseName);
      }
    },
    onCellPrepared(e) {
      if (e.rowType === "data") {
        if(this.firstLoad){
          if (e.data.ClientProjectPhaseID == this.currentClientProjectPhaseID) {
            e.cellElement.style.backgroundColor = "lightcyan";
            this.projectPhaseName = e.data.ProjectPhaseCombinedName;
        }
        }
        if (e.data.ClientProjectPhaseID == this.SelectedProjectPhaseID) {
          e.cellElement.style.backgroundColor = "lightcyan";
        }
      }
    },
    filterChannelsList(cell,data,filterType) {
      let rowData = null;
      if(filterType == 'project'){
        rowData = data.items[0];
      } else {
        rowData = data;
      }
      this.SelectedProjectPhaseID = data.ClientProjectPhaseID;
      this.$refs["projectGrid"].instance.repaint();
      let dataObject = {
        filterType : filterType,
        data : rowData
      };
      cell.data.cellElement.parentElement.style.backgroundColor = "lightcyan";
      this.$emit("filter-channels-list", dataObject);
    },
  },
  created: function () {
    this.SelectedProjectPhaseID = this.clientProjectPhaseID;
  },
};
</script>

<style lang="scss" scoped>
#projectGrid{
   width:35%;
}
// #dashboardChannelMilestones {
//   width: 500px;
// }
</style>